import PropTypes from 'prop-types';
import { useCallback } from 'react';
import FJHeadshotHistoryItemContainer from '../container/FJHeadshotHistoryItemContainer';
import FJLocalStore from '../../../../store/FJLocalStore';
import FJButton, { FJButtonType } from '../../../../common/components/FJButton/FJButton';
import FJConfig from '../../../../config/FJConfig';
import FJSelectAll from '../../../../common/components/FJSelectAll/FJSelectAll';
import FJFileHandleUtil from '../../../../util/FJFileHandleUtil';
import FJAppConstant from '../../../../constants/FJAppConstant';
import FJVerticalScroller from '../../../../common/components/FJScroller/FJVerticalScroller';

import styles from './FJHeadshotHistory.module.less';

const FJHeadshotHistory = ({
    onGetStarted,
    historyList,
    selectList,
    isMultipleMode,
    setSelectList,
    multiDelete,
    clearSelected,
    onDownload,
    active,
}) => {
    const handleMultiDownload = useCallback(
        ids => {
            onDownload?.(ids);
        },
        [onDownload],
    );

    const handleGetStarted = useCallback(() => {
        onGetStarted?.();
    }, [onGetStarted]);

    if (historyList?.length === 0) {
        return (
            <div className={styles.empty_container} style={{ display: active ? 'flex' : 'none' }}>
                <img
                    src={FJFileHandleUtil.getImageUrlWithFormat(
                        `${FJConfig.headshotImagePath}headshot-empty-placeholder.png?v=${FJConfig.version}`,
                    )}
                    alt='no-headshot-created-yet'
                />
                <div className={styles.empty_message}>
                    <p>{FJLocalStore._('no-headshot-created-yet')}</p>
                </div>
                <div className={styles.refresh_button_box}>
                    <div className={styles.refresh_button_shadow}></div>
                    <FJButton
                        onClick={handleGetStarted}
                        className={styles.refresh_button}
                        type={FJButtonType.GRADIENT}
                        text={FJLocalStore._('get-started')}
                    />
                </div>
            </div>
        );
    }

    return (
        <div className={styles.history_container} style={{ display: active ? 'flex' : 'none' }}>
            <div className={styles.header}>
                <h3>{FJLocalStore._('creations')}</h3>
            </div>
            <FJVerticalScroller className={styles.history_list_scroller}>
                <div className={styles.history_list}>
                    {historyList?.map(item => (
                        <FJHeadshotHistoryItemContainer key={item.id} item={item} />
                    ))}
                </div>
            </FJVerticalScroller>
            <FJSelectAll
                appType={FJAppConstant.HEADSHOT_GENERATOR}
                list={historyList}
                selectList={selectList}
                setSelectList={setSelectList}
                multiDelete={multiDelete}
                isMultipleMode={isMultipleMode}
                clearSelected={clearSelected}
                isShowAddToMediaButton={false}
                selectedText={FJLocalStore._(selectList?.length < 2 ? 'project-selected' : 'projects-selected')}
                multiDownload={handleMultiDownload}
            />
        </div>
    );
};

FJHeadshotHistory.propTypes = {
    onGetStarted: PropTypes.func,
    historyList: PropTypes.array,
    historyListStatus: PropTypes.string,
    selectList: PropTypes.array,
    isMultipleMode: PropTypes.bool,
    setSelectList: PropTypes.func,
    multiDelete: PropTypes.func,
    clearSelected: PropTypes.func,
    onDownload: PropTypes.func,
    active: PropTypes.bool,
};

export default FJHeadshotHistory;
